<template>
  <div class="coach">
    <h1>{{competitor.firstname}} {{competitor.lastname}}</h1>
    <p v-if="competitor.club"><b>Primary Club: </b>{{competitor.club.name}}</p>
    <p v-if="competitor.club2"><b>Secondary Club: </b> {{ competitor.club2.name }}</p>
    <h2>Upcoming classes</h2>
    <ul class="classList">
      <ul class="classList" v-if="classes && classes.length > 0" v-model="classes">
        <li v-for="event in classes" class="class" :style="{ borderLeftColor : event.level.color }">
        <classComponent :smallerHeader="true" :passedEvent="event" :passedMe="me" />
        </li>
      </ul>
    </ul>
  </div>
</template>

<script>
import { EventBus } from "../main"
import config from "../config"
import classComponent from "./Class"

export default {
  name: 'coach',
  components : {
    classComponent
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getData()
    })
  },
  beforeRouteUpdate (to, from, next) {
    next(vm => {
      vm.getData()
    })
  },
  created () {
    this.getData()
  },
  methods : {
    setData(d, d2, d3){
      this.me = d3
      this.competitor = d
      this.classes = d2

      this.classes.forEach(c => {
        c.formattedDate = this.formatDate(c.date)
        c.startTime = this.formatTime(c.timestart)
        c.endTime = this.formatTime(c.timeend)
      })

    },
    getData(){
      return new Promise((resolve, reject) => {
        fetch(config.baseUrl+"user/coaches/"+this.$route.params.uuid,{
          credentials : "include"
        }).then(e => {
          return e.json()
        }).then(j => {
          fetch(config.baseUrl+"events/classes/coach/"+j.id, {
            credentials : "include"
          }).then(e => {
            return e.json()
          }).then(j2 => {
            fetch(config.baseUrl+"user/me/", {
              credentials : "include"
            }).then(e => {
              return e.json()
            }).then(j3 => {
              this.setData(j, j2, j3)
              resolve()
            })
          })
        })
      })
    },
    formatDate(date){
      let newDate = new Date(date),
          month = this.getMonth(newDate),
          day = this.getDay(newDate)
      return day + ", " + month +" "+ newDate.getDate()
    },
    getDay(date){
      let day = ""
      switch (date.getDay()) {
        case 0:
          day = "Sunday"
          break
        case 1:
          day = "Monday"
          break
        case 2:
          day = "Tuesday"
          break
        case 3:
          day = "Wednesday"
          break
        case 4:
          day = "Thursday"
          break
        case 5:
          day = "Friday"
          break
        case 6:
          day = "Saturday"
          break
      }
      return day
    },
    getMonth(date){
      let month = ""
      switch (date.getMonth()) {
        case 0:
          month = "January"
          break
        case 1:
          month = "February"
          break
        case 2:
          month = "March"
          break
        case 3:
          month = "April"
          break
        case 4:
          month = "May"
          break
        case 5:
          month = "June"
          break
        case 6:
          month = "July"
          break
        case 7:
          month = "August"
          break
        case 8:
          month = "September"
          break
        case 9:
          month = "October"
          break
        case 10:
          month = "November"
          break
        case 11:
          month = "December"
          break
      }
      return month
    },
    formatTime : function(time){
      let newTime = "",
          splits = time.split(":"),
          hour = 0,
          end = ""
      if(splits[0] > 12){
        hour = parseInt(splits[0]) - 12
        end = "pm"
      } else {
        hour = parseInt(splits[0])
        end = "am"
      }

      if(splits[1] != "00"){
        newTime = hour + ":" + splits[1] + " " + end
      } else {
        newTime = hour + " " + end
      }

      return newTime
    },
  },
  data () {
    return {
      competitor : {},
      classes : []
    }
  },
}
</script>

<style lang="scss">
  .coach {
    padding: 0 20px 0 0;
    .classList {
      list-style: none;
      margin: 0;
      padding: 0;
      > .class {
        padding: 0 0 20px 0;
        margin-bottom: 20px;
        border-bottom: 1px solid #ccc;
        .days {
          text-transform: capitalize;
        }
        .actions {
          margin-top: 20px;
          text-align: right;
        }
        .grid-container {
          display: grid;
          grid-template-columns: auto 250px;
          grid-column-gap: 20px;
        }
        p {
          margin: 0;
        }
      }
    }
  }
</style>
